/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OutputAllUsersDto } from '../../models/output-all-users-dto';

export interface UserManagementGetAllUsersGet$Params {
}

export function userManagementGetAllUsersGet(http: HttpClient, rootUrl: string, params?: UserManagementGetAllUsersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OutputAllUsersDto>>> {
  const rb = new RequestBuilder(rootUrl, userManagementGetAllUsersGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OutputAllUsersDto>>;
    })
  );
}

userManagementGetAllUsersGet.PATH = '/UserManagement/GetAllUsers';
